function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 12.002093,0.16031119 a 11.839689,11.839689 0 1 0 0,23.67937781 11.839689,11.839689 0 0 0 0,-23.67937781 z M 17.788741,16.439883 a 1.2579669,1.2579669 0 0 1 -1.080372,0.606784 1.3023657,1.3023657 0 0 1 -0.651183,-0.177595 L 11.010519,13.775953 A 1.2875661,1.2875661 0 0 1 10.403735,12.695582 V 6.8645349 a 1.257967,1.257967 0 0 1 2.515934,0 V 12 l 4.439883,2.693529 a 1.2727665,1.2727665 0 0 1 0.429189,1.746354 z",
    id: "path2",
    style: {
      strokeWidth: 1.47996
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ddba86f321e37c40fc0116a55acef73b.svg";
export { ForwardRef as ReactComponent };